import React, { useContext, useEffect, useState } from "react";
import { ErrorMessage, Formik, Form } from "formik";
import { registerValidationSchema } from "../../validationSchema/ValidationSchema";
import Button from "../../components/Button";
import TextInput from "../../components/TextInput";
import Phone from "../../components/Phone";
import PasswordInput from "../../components/PasswordInput";
import Dropdown from "../../components/Dropdown";
import Lable from "../../components/Lable";
import { useDispatch, useSelector } from "react-redux";
import { storeRegister } from "../../store/slices/storeSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LoaderContext from "../../components/loader";
import { user_role } from "../../config/apiConfig";
import masterApi from "../../apis/master.api";
import { useFetchAll } from "../../custom/FetchApiHook";
import { FcGoogle } from "react-icons/fc";
import { FaFacebookF } from "react-icons/fa";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../firebase";
import AuthApi from "../../apis/auth.apis";
import ArticleModel from "../Account/ArticleModel";
import { ArticlesApi } from "../../apis/profile.apis";
import GoogleMapsView from "../../components/GoogleMap/GoogleMapsView";

const Register = () => {
  const [mapLocation, setMapLocation] = useState({ lat: 5.5571096, lng: -0.2012376, });
  const dispatch = useDispatch();
  const { handleLoading } = useContext(LoaderContext);
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.store);
  const [countryId, setCountryId] = useState(null);
  const [isApplied, setIsApplied] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [isArticleOpen, setIsArticleOpen] = useState(false);
  const [articleData, setArticleData] = useState("");
  const [articleTitle, setArticleTitle] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [showPhoneOtpField, setShowPhoneOtpField] = useState(false);
  const [phoneOtp, setPhoneOtp] = useState("");
  const countryData = useFetchAll(() => masterApi.getAllCountry());
  const cityData = useFetchAll(
    () => countryId && masterApi.getAllCity(countryId),
  );
  const BuisnessTypeData = useFetchAll(() => masterApi.getAllBuisnessType());
  const { theme } = useSelector((state) => state.theme);

  useEffect(() => {
    handleLoading(loading);
  }, [handleLoading, loading]);

  const googleRegister = (firebaseUser, defaultCountry) => {
    const { displayName, email, phoneNumber, accessToken } = firebaseUser;
    const [first_name, last_name] = displayName
      ? displayName.split(" ")
      : ["", ""];
    return {
      first_name,
      token: accessToken,
      provider: true,
      last_name,
      email,
      phone_number: phoneNumber || "",
      user_role: user_role.vendor,
      country: defaultCountry,
      password: "",
      referral_code: "",
    };
  };

  const signUpWithGoogle = async (setValues) => {
    try {
      const res = await signInWithPopup(auth, googleProvider);
      const user = res.user;
      setValues(googleRegister(user));
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      alert("Google Sign-In failed. Please try again.");
    }
  };

  const initialValues = {
    email: "",
    user_role: user_role.vendor,
    first_name: null,
    ghana_id: null,
    last_name: null,
    phone_number: "",
    address: "",
    gender: "",
    profile_image: null,
    country: null,
    city: null,
    delivery_business: null,
    referral_code: "",
    password: "",
  };

  const country = countryData.value.data
    ? countryData.value.data.map((c, i) => {
        c.label = c.name;
        c.value = c._id;
        return c;
      })
    : [];

  const city = cityData.value.data
    ? cityData.value.data.map((c, i) => {
        c.label = c.name;
        c.value = c._id;
        return c;
      })
    : [];

  const deliveryBusiness = BuisnessTypeData.value.data
    ? BuisnessTypeData.value.data.map((c, i) => {
        c.label = c.name;
        c.value = c._id;
        return c;
      })
    : [];

  // const handleSubmit = async (values) => {
  //   try {
  //     const res = await dispatch(storeRegister(values));
  //     console.log("res.data:",res)
  //     if (res.type === "register/fulfilled") {
  //       navigate("/");
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const handleSubmit = async (values) => {
    if (!values.provider && (!isEmailVerified || !isPhoneVerified)) {
      toast.error("Please verify your email and phone number before registering");
      return;
    }
    try {
      const action = await dispatch(storeRegister(values));

      if (storeRegister.fulfilled.match(action)) {
        navigate("/");
      } else {
        console.log("Register failed:", action.payload || action.error);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleReferral = async (values) => {
    console.log("Applying referral code:", values.referral_code);
    const payload = {
      referral_code: values.referral_code,
    };
    console.log(values);
    handleLoading(true);
    try {
      const res = await AuthApi.referralCode(payload);
      setReferralCode(values.referral_code);
      toast.success("Referral code added successfully");
      setIsApplied(true);
      console.log(res.data);
    } catch (err) {
      console.log(err.response?.data?.message);
      toast.error(err.response?.data?.message);
    } finally {
      handleLoading(false);
    }
  };

  const handleDeleteCode = () => {
    setReferralCode("");
    setIsApplied(false);
  };

  useEffect(() => {
    cityData.fetchAllData();
  }, [countryId]);

  const handleSendOtp = async (email) => {
    if (!email) return toast.error("Please enter email first");
    handleLoading(true);
    try {
      await AuthApi.sendEmailVerificationOtp({ email });
      toast.success("OTP sent to your email");
      setShowOtpField(true);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send OTP");
    } finally {
      handleLoading(false);
    }
  };

  const handleVerifyOtp = async (email) => {
    if (!emailOtp) return toast.error("Please enter OTP");
    handleLoading(true);
    try {
      await AuthApi.verifyEmailVerificationOtp({ email, otp: emailOtp });
      toast.success("Email verified successfully");
      setIsEmailVerified(true);
      setShowOtpField(false);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to verify OTP");
    } finally {
      handleLoading(false);
    }
  };

  const handleSendPhoneOtp = async (phone_number) => {
    if (!phone_number) return toast.error("Please enter phone number first");
    handleLoading(true);
    try {
      await AuthApi.sendPhoneVerificationOtp({ phone_number });
      toast.success("OTP sent to your phone");
      setShowPhoneOtpField(true);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send OTP");
    } finally {
      handleLoading(false);
    }
  };

  const handleVerifyPhoneOtp = async (phone_number) => {
    if (!phoneOtp) return toast.error("Please enter OTP");
    handleLoading(true);
    try {
      await AuthApi.verifyPhoneVerificationOtp({ phone_number, otp: phoneOtp });
      toast.success("Phone verified successfully");
      setIsPhoneVerified(true);
      setShowPhoneOtpField(false);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to verify OTP");
    } finally {
      handleLoading(false);
    }
  };

  const handleArticle = async (type) => {
    setIsArticleOpen(true);
    setArticleTitle(type);
    handleLoading(true);

    try {
      const data = await ArticlesApi.getArticlesDetails();
      console.log("API Article data:", data.data.data);
      // Choose which article content to display based on the type
      const articleContent =
        type === "TNC"
          ? data.data.data[0].storeTermsAndConditions
          : data.data.data[0].storePrivacyPolicy;

      setArticleData(articleContent);
    } catch (error) {
      console.error("Error fetching article data:", error);
      toast.error(error.message);
    } finally {
      handleLoading(false);
    }
  };

  // Closing the modal
  const handleClose = () => {
    setIsArticleOpen(false);
    setArticleData("");
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={registerValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ handleChange, setFieldValue, values, setValues }) => (
        <>
          <div
            className={`flex flex-col items-center justify-center gap-5 my-10  ${
              theme === "light" ? "" : " text-darkSecondary"
            }`}
          >
            <div className="flex gap-5 items-center justify-center ">
              <span className=" flex items-center justify-center gap-3 cursor-pointer w-full rounded-full bg-[#efeeee]  p-2 shadow-2xl">
                <FcGoogle
                  className="text-4xl cursor-pointer"
                  onClick={() => signUpWithGoogle(setValues)}
                />
                {/* <span className=" font-semibold text-lg text-[#303030] "></span> */}
              </span>
              <span className=" flex items-center justify-center gap-3 cursor-pointer w-full rounded-full bg-[#506dc0] p-2 shadow-2xl ">
                <FaFacebookF
                  className="text-3xl cursor-pointer "
                  style={{ color: "white" }}
                />
                {/* <span
                      className=" font-semibold text-lg text-[#303030] "
                      // onClick={signUpWithGoogle}
                    ></span> */}
              </span>
            </div>
            <span
              className={` ${
                theme === "light" ? "text-primaryColor" : " text-darkSecondary"
              }`}
            >
              Or
            </span>
          </div>
          <Form className="mt-12">
            <div
              className={`gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3 ${
                theme === "light" ? "text-primaryColor" : " text-darkSecondary"
              }`}
            >
              <Lable lable="Store Name" />
              <div>
                <TextInput
                  name="first_name"
                  type="text"
                  placeholder="Store Name"
                  onChange={handleChange}
                  value={values.first_name}
                />
                <ErrorMessage
                  name="first_name"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="E-Mail" />
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <div className="flex-1">
                    <TextInput
                      name="email"
                      type="email"
                      placeholder="E-mail"
                      onChange={handleChange}
                      value={values.email}
                      disabled={isEmailVerified}
                    />
                  </div>
                  {!isEmailVerified && values.email && (
                    <button
                      type="button"
                      className="bg-buttonColor text-secondaryColor px-4 text-xs font-bold rounded whitespace-nowrap"
                      onClick={() => handleSendOtp(values.email)}
                    >
                      {showOtpField ? "Resend OTP" : "Send OTP"}
                    </button>
                  )}
                  {isEmailVerified && (
                    <span className="text-green-600 text-sm flex items-center whitespace-nowrap">✓ Verified</span>
                  )}
                </div>
                {showOtpField && !isEmailVerified && (
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      className={`border p-2 w-full rounded outline-none ${
                        theme === "light"
                          ? "bg-[#efeeee] text-[#303030]"
                          : "bg-[#252525] text-white"
                      }`}
                      value={emailOtp}
                      onChange={(e) => setEmailOtp(e.target.value)}
                    />
                    <button
                      type="button"
                      className="bg-buttonColor text-secondaryColor px-4 text-xs font-bold rounded whitespace-nowrap"
                      onClick={() => handleVerifyOtp(values.email)}
                    >
                      Verify OTP
                    </button>
                  </div>
                )}
                <ErrorMessage name="email" component="div" className="error" />
              </div>
            </div>

            {/* <div
              className={`gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3 ${
                theme === "light" ? "text-primaryColor" : " text-darkSecondary"
              }`}
            >
              <Lable lable="Ghana ID" />
              <div>
                <TextInput
                  name="ghana_id"
                  type="text"
                  placeholder="Ghana ID"
                  onChange={handleChange}
                  value={values.ghana_id}
                />
                <ErrorMessage
                  name="ghana_id"
                  component="div"
                  className="error"
                />
              </div>
            </div> */}

            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="Country" />
              <div>
                <Dropdown
                  options={country}
                  name="country"
                  value={values.country}
                  handleOnchange={(v) => {
                    setCountryId(v._id);
                    setFieldValue("country", v._id);
                  }}
                />
                <ErrorMessage
                  name="country"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="City" />
              <div>
                <Dropdown
                  options={city}
                  name="city"
                  value={values.city}
                  handleOnchange={(v) => {
                    setFieldValue("city", v._id);
                    if (v.latitude && v.longitude) {
                      setMapLocation({
                        lat: Number(v.latitude),
                        lng: Number(v.longitude),
                      });
                    }
                  }}
                />
                <ErrorMessage name="city" component="div" className="error" />
              </div>
            </div>

            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="Phone" />
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <div className="flex-1">
                    <Phone value={values.phone_number} name="phone_number" disabled={isPhoneVerified} />
                  </div>
                  {!isPhoneVerified && values.phone_number && (
                    <button
                      type="button"
                      className="bg-buttonColor text-secondaryColor px-4 text-xs font-bold rounded whitespace-nowrap"
                      onClick={() => handleSendPhoneOtp(values.phone_number)}
                    >
                      {showPhoneOtpField ? "Resend OTP" : "Send OTP"}
                    </button>
                  )}
                  {isPhoneVerified && (
                    <span className="text-green-600 text-sm flex items-center whitespace-nowrap">✓ Verified</span>
                  )}
                </div>
                {showPhoneOtpField && !isPhoneVerified && (
                  <div className="flex gap-2">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      className={`border p-2 w-full rounded outline-none ${
                        theme === "light"
                          ? "bg-[#efeeee] text-[#303030]"
                          : "bg-[#252525] text-white"
                      }`}
                      value={phoneOtp}
                      onChange={(e) => setPhoneOtp(e.target.value)}
                    />
                    <button
                      type="button"
                      className="bg-buttonColor text-secondaryColor px-4 text-xs font-bold rounded whitespace-nowrap"
                      onClick={() => handleVerifyPhoneOtp(values.phone_number)}
                    >
                      Verify OTP
                    </button>
                  </div>
                )}
                <ErrorMessage
                  name="phone_number"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="Password" />
              <div>
                <PasswordInput
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  value={values.password}
                  autoComplete
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            {/* {isApplied && (
              <div className="flex items-center justify-between bg-gren100 text-green800 p-2 rounded-md mb-3">
                <span>Referral Code: {referralCode}</span>
                <button
                  onClick={handleDeleteCode}
                  className="text-red500 font-bold"
                >
                  x
                </button>
              </div>
            )}
            <div className="gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3">
              <Lable lable="Referral Code" />
              <div>
                <div
                  className={`flex  ${
                    theme === "light"
                      ? "text-primaryColor"
                      : " text-darkSecondary"
                  }`}
                >
                  <TextInput
                    name="referral_code"
                    type="text"
                    placeholder="Referral Code"
                    onChange={handleChange}
                    value={values.referral_code}
                    isApplied={isApplied}
                  />
                  {!isApplied && (
                    <button
                      className=" bg-buttonColor text-secondaryColor uppercase px-4 text-xs font-bold rounded-r-full"
                      onClick={() => handleReferral(values)}
                    >
                      Apply
                    </button>
                  )}
                </div>
                <ErrorMessage
                  name="referral_code"
                  component="div"
                  className="error"
                />
              </div>
            </div> */}
            <div
              className={`gap-3  grid grid-cols-1 sm:grid-cols-2 items-center mb-3 ${
                theme === "light" ? "text-primaryColor" : " text-darkSecondary"
              }`}
            >
              <Lable lable="Address" />
              <div>
                <TextInput
                  name="address"
                  type="text"
                  placeholder="Address"
                  onChange={handleChange}
                  value={values.address}
                />
                <ErrorMessage
                  name="address"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <GoogleMapsView
              lat={mapLocation.lat}
              lng={mapLocation.lng}
              getAddress={(address, latLng) => {
                setFieldValue("latitude", Number(latLng.lat));
                setFieldValue("longitude", Number(latLng.lng));

                if (address) {
                  setFieldValue("address", address);
                }
              }}
            />
            <div className="flex gap-2 mt-4 items-start">
              <input type="checkbox" className="mb-2" required />

              {/* Updated Label with clickable Terms and Privacy links */}
              <p
                className={`text-sm ${
                  theme === "light"
                    ? "text-primaryColor"
                    : " text-darkSecondary"
                }`}
              >
                I agree to the{" "}
                <span
                  className="text-buttonColor cursor-pointer hover:underline"
                  onClick={() => handleArticle("TNC")}
                >
                  Terms & Conditions
                </span>{" "}
                and{" "}
                <span
                  className="text-buttonColor cursor-pointer hover:underline"
                  onClick={() => handleArticle("PP")}
                >
                  Privacy Policy
                </span>
              </p>
            </div>

            <div className="mt-3">
              <Button text={"Signup"} type={"submit"} />
            </div>
          </Form>
          {isArticleOpen && (
            <ArticleModel
              data={articleData}
              title={
                articleTitle === "TNC"
                  ? "Terms and Conditions"
                  : "Privacy Policy"
              }
              onClose={handleClose}
            />
          )}
        </>
      )}
    </Formik>
  );
};

export default Register;
